import { LayoutState } from '~/src/stores/layout'
import LayoutServiceInterface, { GetLayoutArgs } from '~/src/utils/layout/LayoutServiceInterface'

export default class LayoutLocationsServiceStyleThree implements LayoutServiceInterface {
  public getLayout({ isMobile }: GetLayoutArgs): Partial<LayoutState> {
    return {
      header: {
        display: !isMobile,
        displayMenuBurger: true,
        displayProductSearch: false,
        displayLocationSearch: false,
        displayCart: false,
        displayLanguagesSelector: true,
        displayDeliveryOptions: false,
        displayUserActions: false,
        displayCurrentFirm: false,
        logo: {
          disableLink: false
        },
        title: '',
        type: 'navigation'
      },
      subHeader: {
        display: !isMobile,
        variant: 'small'
      },
      content: {
        displayNotification: false
      },
      mainSideBar: {
        display: false,
        displayCart: false,
        displayDeliveryOptions: false,
        displayOrderSummary: false
      },
      footer: {
        display: false,
        displayGoToCartBtn: false,
        displayGoToCheckoutBtn: false,
        displayInformations: true,
        displayLinks: true
      },
      mobileNavigation: {
        display: true
      }
    }
  }
}
